import { useCallback, useRef } from "react";
import { STIP_BASE_URL } from "../../../props";
import axios from "axios";
import {
  doPutWithoutAuth,
  usePost,
  usePostWithoutLocation,
} from "../../../common/fetchServices";
import { useMutation } from "@tanstack/react-query";

const getUploadRequestUrl = () => `${STIP_BASE_URL}/file-upload/request`;
const getCreatorUploadUrl = () => `${STIP_BASE_URL}/creator/upload`;
const getReprocessSubmissionUrl = ({ submissionId }) =>
  `${STIP_BASE_URL}/creator/upload/reprocess/${submissionId}`;

export const useRequestUploadUrl = () => {
  return usePost(getUploadRequestUrl);
};

export const useUploadUserFile = () => {
  return useMutation({
    mutationFn: ({ uploadUrl, fileBlob }) => {
      return doPutWithoutAuth(uploadUrl, fileBlob, {
        headers: {
          "Content-Type": fileBlob.type,
        },
      });
    },
  });
};

export const useUploadUserSubmission = () => {
  return usePostWithoutLocation(getCreatorUploadUrl, {
    queriesToInvalidate: [["content-processing"]],
  });
};

export const useReprocessSubmission = () => {
  return usePost(getReprocessSubmissionUrl, {
    queriesToInvalidate: [["content-processing"]],
  });
};

export const useUploadUserFileWithProgress = () => {
  const abortControllerRef = useRef(null);

  const mutation = useMutation({
    mutationFn: ({ uploadUrl, fileBlob, progressEventHandler }) => {
      abortControllerRef.current = new AbortController();

      return axios.put(uploadUrl, fileBlob, {
        headers: {
          "Content-Type": fileBlob.type,
          Origin: document.location.origin,
        },
        signal: abortControllerRef.current.signal,
        onUploadProgress: progressEventHandler,
      });
    },
  });

  const abort = useCallback(() => {
    if (abortControllerRef.current) {
      abortControllerRef.current.abort();
    }

    mutation.reset();
  }, [mutation]);

  return {
    ...mutation,
    abort,
  };
};
